module.exports = __webpack_public_path__ + "static/media/7.56946666.jpg";